import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CustomerTypeSPArrayModel, CustomerTypeSPModel } from "../../models/CustomerTypeSPModel";

const initialCustomerTypeSPState: CustomerTypeSPArrayModel = {
    particular_customerTypeSP :{
        "customerTypeId": 0,
        "name": ""
    }
}

const CustomerTypeSPSlice = createSlice({
    name: 'CustomerTypeSP',
    initialState: initialCustomerTypeSPState,
    reducers: {
        setParticularCustomerTypeSP(state, action: PayloadAction<CustomerTypeSPModel>) {
            state.particular_customerTypeSP = action.payload;
        }
    }
})
export default CustomerTypeSPSlice;